
import { io } from "socket.io-client";

export const socket = io("https://getlink.world/socket.io/", {
  autoConnect: false,
  transports: ["websocket"],
});